import React, { useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import "./index.scss";

export const RelatedSection = ({ categories }: any) => {
  const data = useStaticQuery(graphql`
    query relatedQuery {
      allWpPost {
        nodes {
          title
          slug
          id
          featuredImage {
            node {
              title
              altText
              gatsbyImage(
                fit: COVER
                quality: 100
                breakpoints: 1
                width: 1000
                height: 600
                formats: WEBP
              )
            }
          }
          categories {
            nodes {
              slug
              name
            }
          }
        }
      }
    }
  `);

  const categorySlugs = categories.map((category: any) => category.slug);

  const filteredPosts = data.allWpPost.nodes.filter((post: any) =>
    post.categories.nodes.some((category: any) =>
      categorySlugs.includes(category.slug)
    )
  );

  const [currentSlide, setCurrentSlide] = React.useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    breakpoints: {
      "(min-width: 0px)": {
        slides: {
          spacing: 10,
          perView: 1.1,
        },
      },
      "(min-width: 635px)": {
        slides: {
          spacing: 15,
          perView: 1.5,
        },
      },
      "(min-width: 768px)": {
        slides: {
          spacing: 20,
          perView: 2,
        },
      },
      "(min-width: 1025px)": {
        slides: {
          spacing: 25,
          perView: 3,
        },
      },
      "(min-width: 1500px)": {
        slides: {
          spacing: 30,
          perView: 3.5,
        },
      },
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
  });

  return (
    <div
      id="location__related"
      className="section__container bg__light2 text__primary"
    >
      <div className="inner-container">
        <div className="inner">
          <div className="inner__presentation">
            <h2 className="presentation__title">More news</h2>
            <div className="section__separator color__primary-dark mobile-hidden"></div>
          </div>
          <div className="carousel">
            <div ref={sliderRef} className="keen-slider">
              {filteredPosts ? (
                filteredPosts.map((post: any, index: number) => (
                  <div
                    className="keen-slider__element keen-slider__slide"
                    key={index}
                  >
                    <div className="card">
                      {post.featuredImage && (
                        <GatsbyImage
                          alt={post.featuredImage.node.altText}
                          image={post.featuredImage.node.gatsbyImage}
                          className="card__image"
                        />
                      )}
                      <h3 className="card__title">{post.title}</h3>
                      <Link
                        className="booking-link"
                        to={`/news/${post.slug}`}
                        title={`Checkout ${post.title} post`}
                      >
                        <button className="button style-primary-outline custom-styled-primary go-ornament no-scale">
                          Learn more
                        </button>
                      </Link>
                    </div>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>

            {loaded && instanceRef.current && (
              <div className="dots">
                {[
                  ...Array(
                    instanceRef.current.track.details?.slides.length
                  ).keys(),
                ].map((idx) => {
                  return (
                    <button
                      key={idx}
                      onClick={() => {
                        instanceRef.current?.moveToIdx(idx);
                      }}
                      className={
                        "dot" + (currentSlide === idx ? " active" : "")
                      }
                    ></button>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
